import useAppModelChange from "@src/backbone/hooks/useAppModelChange";
import useCartModelChange from "@src/backbone/hooks/useCartModelChange";
import { IStoreClosure } from "@src/backbone/model/StoreModel";
import { useEffect, useState, useMemo } from "react";

export const useGetEndOfServiceTime = () => {
  const [cartData, cart] = useCartModelChange(["id_store"]);
  const [appData] = useAppModelChange(["cart"]);
  const [storeClosure, setStoreClosure] = useState<IStoreClosure | null>(null);

  const closingTime = useMemo(() => {
    const store = cart.getStore();
    if (store) {
      const storeClosingTime = store.getEndOfService(
        new Date(),
        cart?.isVAE() ?? false
      );

      return storeClosingTime;
    }
  }, [cart, cartData, appData, storeClosure]);

  useEffect(() => {
    const store = cart.getStore();
    const onClosureChange = (closure: IStoreClosure) => {
      if (store) {
        setStoreClosure(closure);
      }
    };
    if (store) {
      store.on("change:closure", onClosureChange);
    }
    return () => {
      if (store) {
        store.off("change:closure", onClosureChange);
      }
    };
  }, [cart]);

  // get minutes until closing time

  const getRemainingTimeOfEndOfService = () => {
    if (!closingTime) return null;
    return Math.ceil(
      (closingTime.getTime() - new Date().getTime()) / (1000 * 60)
    );
  };

  const getNextOpeningTime = () => {
    if (!closingTime) return null;
    const now = new Date();
    if (now > closingTime) {
      const store = cart.getStore();
      if (store) {
        return store.nextOpeningTime(now, cart?.isVAE() ?? false);
      }
    }
    return null;
  };

  const timeToClosingTime = getRemainingTimeOfEndOfService();

  return {
    closingTime,
    store: cart.getStore(),
    storeId: cartData.id_store,
    timeToClosingTime,
    getNextOpeningTime,
    getRemainingTimeOfEndOfService,
  };
};
